<template>
    <div>
        <section class="xlrclh">
            <img class="top-img" src="./../assets/imgs/27/title-bg.png" alt="" />
            <div class="technological-process">
                <div class="sxcl">
                    <img class="top" src="./../assets/imgs/27/title-1.png" alt="" />
                    <div class="content">
                        成华区所有职工（含工商行政管理注册地在成华区或税收关系在成华区的企业和职工、农民工）。
                    </div>
                </div>
                <div class="sxcl">
                    <img class="top" src="./../assets/imgs/27/title-2.png" alt="" />
                    <div class="content">
                        评选条件包括基础条件和技能条件。在符合基础条件的情况下，技能条件具备一个即可申报。
                    </div>
                </div>
                <div class="zccl">
                    <img class="top" src="./../assets/imgs/27/title-3.png" alt="" />
                    <div class="content">
                        <div class="des">
                            <div class="title">一. 资金支持</div>
                            一次性奖励5000元。
                        </div>
                        <div class="des">
                            <div class="title">二. 荣誉记录</div>
                            颁发荣誉证书，因退休、工作调动离开本区的，保留工匠称号。
                        </div>
                        <div class="des">
                            <div class="title">三. 晋升支持</div>
                            可优先推荐参加“成都工匠”和“成都工匠十大领军人物”的评选活动。
                        </div>
                        <div class="des">
                            <div class="title">四. 其他</div>
                            入选者享受区政府技能人才有关优惠政策和社会礼遇服务。
                        </div>
                    </div>
                </div>
                <div class="sbcl">
                    <img class="top" src="./../assets/imgs/25/title-3.png" alt="" />
                    <div class="content">
                        <div class="des">
                            <div class="title">个人申报</div>
                            <div class="item">
                                <div class="line"></div>
                                <div class="dot">1</div>
                                个人申报
                            </div>
                            <div class="item">
                                <div class="line"></div>
                                <div class="dot">2</div>
                                部门、街道（产业功能区管委会）初审
                            </div>
                            <div class="item">
                                <div class="line"></div>
                                <div class="dot">3</div>
                                区总工会审核
                            </div>
                            <div class="item">
                                <div class="line"></div>
                                <div class="dot">4</div>
                                专家评审
                            </div>
                            <div class="item">
                                <div class="line"></div>
                                <div class="dot">5</div>
                                社会公示
                            </div>
                            <div class="item">
                                <div class="line"></div>
                                <div class="dot">6</div>
                                区人才工作领导小组审批确定人选
                            </div>
                            <div class="item">
                                <div class="dot">7</div>
                                确定人选
                            </div>
                        </div>
                        <div class="des">
                            <div class="title">
                                部门、街道（产业功能区管委会）推荐
                            </div>
                            <div class="item">
                                <div class="line"></div>

                                <div class="dot">1</div>
                                部门、街道（产业功能区管委会）推荐
                            </div>
                            <div class="item">
                                <div class="line"></div>

                                <div class="dot">2</div>
                                部门、街道（产业功能区管委会）初审
                            </div>
                            <div class="item">
                                <div class="line"></div>
                                <div class="dot">3</div>
                                区总工会审核
                            </div>
                            <div class="item">
                                <div class="line"></div>
                                <div class="dot">4</div>
                                专家评审
                            </div>
                            <div class="item">
                                <div class="line"></div>
                                <div class="dot">5</div>
                                社会公示
                            </div>
                            <div class="item">
                                <div class="line"></div>
                                <div class="dot">6</div>
                                区人才工作领导小组审批确定人选
                            </div>
                            <div class="item">
                                <div class="dot">7</div>
                                确定人选
                            </div>
                        </div>
                        <div class="des">
                            <div class="title">企业推荐</div>
                            <div class="item">
                                <div class="line"></div>

                                <div class="dot">1</div>
                                企业推荐
                            </div>
                            <div class="item">
                                <div class="line"></div>

                                <div class="dot">2</div>
                                企业初审
                            </div>
                            <div class="item">
                                <div class="line"></div>
                                <div class="dot">3</div>
                                区总工会审核
                            </div>
                            <div class="item">
                                <div class="line"></div>
                                <div class="dot">4</div>
                                专家评审
                            </div>
                            <div class="item">
                                <div class="line"></div>
                                <div class="dot">5</div>
                                社会公示
                            </div>
                            <div class="item">
                                <div class="line"></div>
                                <div class="dot">6</div>
                                区人才工作领导小组审批确定人选
                            </div>
                            <div class="item">
                                <div class="dot">7</div>
                                确定人选
                            </div>
                        </div>
                        <div class="des">
                            <div class="title">行业协会推荐</div>
                            <div class="item">
                                <div class="line"></div>

                                <div class="dot">1</div>
                                行业协会推荐
                            </div>
                            <div class="item">
                                <div class="line"></div>

                                <div class="dot">2</div>
                                行业协会初审
                            </div>
                            <div class="item">
                                <div class="line"></div>
                                <div class="dot">3</div>
                                区总工会审核
                            </div>
                            <div class="item">
                                <div class="line"></div>
                                <div class="dot">4</div>
                                专家评审
                            </div>
                            <div class="item">
                                <div class="line"></div>
                                <div class="dot">5</div>
                                社会公示
                            </div>
                            <div class="item">
                                <div class="line"></div>
                                <div class="dot">6</div>
                                区人才工作领导小组审批确定人选
                            </div>
                            <div class="item">
                                <div class="dot">7</div>
                                确定人选
                            </div>
                        </div>
                    </div>
                </div>

                <div class="contact">
                    <img class="top" src="./../assets/imgs/25/title-5.png" alt="" />
                    <div class="content">
                        <div class="number">
                            <span class="label">政策咨询电话：</span>
                            <div>
                                <a href="tel:028-84313004">028-84313004</a>
                            </div>
                        </div>
                        <div class="unit">
                            <span class="label">责任单位：</span>
                            成华区总工会
                        </div>
                    </div>
                </div>
                <div class="mark">
                    申请时间：每年评选一次，依据通知时间确定。
                </div>
            </div>
        </section>
        <!-- <call phone="028-83221725"></call> -->
    </div>
</template>

<script>
import call from "../components/call.vue";
export default {
    data() {
        return {};
    },

    components: {
        call,
    },

    mounted() { },

    methods: {},
};
</script>
<style lang="scss" scoped>
@import "@/assets/public.scss";

.xlrclh {
    background-color: $base-back;

    .top-img {
        width: 7.26rem;
        height: 4.4rem;
    }

    .technological-process {
        transform: translateY(-1.4rem);

        .sxcl {
            position: relative;
            margin-top: 0.22rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #fff;
                margin: -0.45rem auto 0;
                padding: 0.33rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                padding-top: 0.28rem;
                font-size: 0.26rem;
                font-weight: 500;
                text-align: left;
                color: #4e4e4e;
                line-height: 0.44rem;
            }
        }

        .zccl {
            position: relative;
            margin-top: 0.22rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #e8eeff;
                margin: -0.45rem auto 0;
                padding: 0.33rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                padding-top: 0.28rem;
                font-size: 0.26rem;
                font-weight: 500;
                text-align: left;
                color: #4e4e4e;

                .des {
                    color: #4e4e4e;
                    text-align: left;
                    background: #ffffff;
                    border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                    padding: 0.35rem 0.23rem 0.3rem;
                    margin-top: 0.8rem;
                    position: relative;
                    text-align: center;
                    line-height: 0.44rem;

                    .title {
                        position: absolute;
                        top: -0.5rem;
                        left: 50%;
                        transform: translateX(-50%);
                        width: 2.98rem;
                        height: 0.67rem;
                        line-height: 0.67rem;
                        display: flex;
                        justify-content: center;
                        align-content: center;
                        font-size: 0.32rem;
                        font-weight: bold;
                        color: #ffffff;
                        border-radius: 1rem;
                        background-color: #739bfe;
                    }
                }
            }
        }

        .sbcl {
            position: relative;
            margin-top: 0.22rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #e8eeff;
                margin: -0.45rem auto 0;
                padding: 0 0.33rem 0.64rem 0.36rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                padding-top: 0.28rem;
                font-size: 0.26rem;
                font-weight: 500;
                text-align: left;
                color: #4e4e4e;

                .des {
                    color: #4e4e4e;
                    text-align: left;
                    background: #ffffff;
                    border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                    padding: 0.35rem 0.23rem 0.3rem;
                    margin-top: 0.8rem;
                    position: relative;

                    .title {
                        position: absolute;
                        top: -0.5rem;
                        left: 50%;
                        transform: translateX(-50%);
                        width: 4.5rem;
                        height: 0.67rem;
                        line-height: 0.67rem;
                        display: flex;
                        justify-content: center;
                        align-content: center;
                        font-size: 0.24rem;
                        font-weight: bold;
                        color: #ffffff;
                        border-radius: 1rem;
                        background-color: #739bfe;
                    }

                    .item {
                        margin-top: 0.35rem;
                        box-sizing: border-box;
                        position: relative;
                        padding-left: 0.42rem;
                        display: flex;

                        .line {
                            position: absolute;
                            width: 0.02rem;
                            height: 135%;
                            border-left: 0.02rem dashed #739bfe;
                            left: 0.1rem;
                            top: 0.2rem;
                            z-index: 0;
                            //   background-color: #739bfe;
                        }

                        .dot {
                            width: 0.39rem;
                            height: 0.39rem;
                            background-color: #739bfe;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            font-size: 0.28rem;
                            color: #fff;
                            border-radius: 50%;
                            position: absolute;
                            left: -0.1rem;
                            top: 0;
                            z-index: 9999;
                        }
                    }
                }
            }
        }

        .mark {
            width: 6.85rem;
            background: #ffffff;
            margin: 0 auto;
            padding: 0.33rem;
            box-sizing: border-box;
            border-radius: 0.26rem;
            padding-top: 0.28rem;
            margin-top: 0.22rem;

            text-align: left;
            color: #4e4e4e;
            font-size: 0.34rem;
            font-weight: 800;
            color: #2350bf;
        }
    }
}
</style>
